// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3Bavu","list":"styles_list__2frlc"};